import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    editBusinessProfile: [],
    loading: false,
    error: null,
}

const editBusinessProfileSlice = createSlice({
    name: "editBusinessProfile",
    initialState,
    reducers: {
        fetchBusinessProfileSuccess: (state, action) => {
            state.loading = false,
            state.editBusinessProfile = action.payload;
        },
        fetchBusinessProfileFailure: (state, action) => {
            state.loading = false,
            state.error = action.payload;
        },
    },
})

export const {
    fetchBusinessProfileSuccess,
    fetchBusinessProfileFailure,
} = editBusinessProfileSlice.actions;

export default editBusinessProfileSlice.reducer;